import type { GrowthCategory, GrowthContent } from '@mc/api'
import { useStaticData } from '@mc/static-data-react'
import { PageSource } from '@mc/track-event'

import { SubcatCourses } from 'components/SubcatCourses'

export const SubcatCoursesSection = () => {
  const {
    otherClassesInSameSubcategories,
    primaryCategory,
    primarySubcategory,
  } = useStaticData<{
    otherClassesInSameSubcategories: GrowthContent[]
    primaryCategory: GrowthCategory
    primarySubcategory: GrowthCategory
  }>()

  if (
    !otherClassesInSameSubcategories ||
    otherClassesInSameSubcategories.length === 0
  ) {
    return null
  }

  return (
    <SubcatCourses
      classes={otherClassesInSameSubcategories}
      primaryCategory={primaryCategory}
      subcategories={[primarySubcategory]}
      pageSource={PageSource.OUTCOME}
    />
  )
}
